module.exports = __webpack_public_path__ + "main/assets/fonts/petalmd/petalmd-4b61fd46bdac77573e3801ad42f27baf.woff2";


//////////////////
// WEBPACK FOOTER
// ./main/assets/fonts/petalmd/petalmd.woff2
// module id = 471
// module chunks = 0